import { EmailLink, PersonNameTableCell, WhatsAppLink } from '@repo/ui';
import { GetAllPersonsFromGroupUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';

export const makeColumnsGroupSettingsPersonsFromGroupList = (): TableColumn<
  GetAllPersonsFromGroupUseCaseInterface.Result[number]
>[] => {
  return [
    {
      name: 'Nome',
      wrap: true,
      sortable: true,
      selector: (row) => row.name,
      cell: (row) => (
        <PersonNameTableCell cpf={row.cpf} name={row.name} imgSrc={row.photo} />
      ),
    },
    {
      name: 'Telefone',
      selector: (row) => row.phone,
      cell: (row) =>
        row.phone ? <WhatsAppLink telephone={row.phone} /> : <></>,
    },
    {
      name: 'Email',
      wrap: true,
      sortable: true,
      selector: (row) => row.email,
      cell: (row) => <EmailLink email={row.email} />,
    },
  ];
};
